
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-point",
  components: {},
})
export class IconPoint extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
  @Prop({ default: "#ffd102" }) public color2!: string;

  constructor() {
    super();
  }
}
export default IconPoint;
